/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'enum': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M24.774 951.742h677.161V64H24.775v887.742zm84.645-803.097H617.29v697.807H109.42V148.645z"/><path pid="1" d="M173.42 233.29h379.87v84.645H173.42V233.29zM173.42 381.935h379.87v84.646H173.42v-84.646zM173.42 528.516h379.87v84.645H173.42v-84.645zM173.42 677.161h379.87v84.645H173.42v-84.645zM829.935 233.29h169.29v592.516h-169.29V233.29zM973.42 24.774C956.215 8.258 936.257 0 913.547 0s-42.322 8.258-58.838 24.774-24.775 36.474-24.775 59.871v84.645h169.29V84.645c0-23.397-8.602-43.355-25.806-59.87zM912.516 1024l86.71-136.258H827.87z"/>'
  }
})
